import { useRecoilState } from 'recoil';
import { 
  ClockIcon, 
  CalendarIcon
} from '@heroicons/react/24/outline';

// Recoil State Import
import workOrderValueAtom from '../atoms/workOrderValueAtom';


function AppointmentCard({ appointments = [], fetchAppointmentDetails }) {
  const [workOrder, setWorkOrder] = useRecoilState(workOrderValueAtom);

  const defaultWorkOrder = {
    serviceBundle: {data: [], note: ''},
    serviceList: {data: [], note: ''},
    materialList: {data: [], note: ''},
    otherList: {data: [], note: ''},
    technicianCost: '0',
    estimatedCompletionDate: '',
    estimatedCompletionTime: ''
  }

  return (
    <div className="bg-white rounded-lg shadow-sm">
      {/* Appointments List */}
      <div className="overflow-y-auto">
        {appointments.length === 0 ? (
          <div className="p-4 text-center text-gray-500">
            No appointments found
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-3 p-4">
            {appointments.map((appointment,index) => (
                <div 
                  key={`${appointment.id}-${index}`}
                  onClick={() => {
                    fetchAppointmentDetails(appointment.id);
                    setWorkOrder(defaultWorkOrder);
                  }}
                  className="bg-gray-50 p-4 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors cursor-pointer"
                >
                  {/* Top Row */}
                  <div className="flex justify-between items-start">
                    <div>
                      <h3 className="text-sm font-medium text-gray-900">
                        {appointment.make} {appointment.model}
                      </h3>
                      <div className="flex items-center gap-3 mt-1 text-xs text-gray-500">
                        <span className="flex items-center">
                          <CalendarIcon className="h-3.5 w-3.5 mr-1" />
                          {appointment.date}
                        </span>
                        <span className="flex items-center">
                          <ClockIcon className="h-3.5 w-3.5 mr-1" />
                          {appointment.time}
                        </span>
                      </div>
                    </div>
                    <span className={`px-2 py-1 rounded-full text-xs ${
                      appointment.status === 'Completed' 
                        ? 'bg-green-100 text-green-700'
                        : 'bg-blue-50 text-blue-700'
                    }`}>
                      {appointment.status || 'Pending'}
                    </span>
                   
                  </div>

                  {/* Location */}
                  {/* <div className="mt-2 flex items-start gap-1 text-xs text-gray-600">
                    <svg 
                      className="h-3.5 w-3.5 mt-0.5 text-gray-400 flex-shrink-0" 
                      xmlns="http://www.w3.org/2000/svg" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span className="line-clamp-1">{appointment.location || 'Location not specified'}</span>
                  </div> */}

                  {/* Description */}
                  {appointment.problemDescription && (
                    <div className="mt-2 text-xs text-gray-600 line-clamp-2">
                      {appointment.problemDescription}
                    </div>
                  )}
                     <p className="text-xs mt-2 text-gray-600">
                     Work Estimate Status: 
                     {appointment?.pilot_estimate === null ? <span className="text-red-500 ml-2 bg-red-100 px-2 py-1 rounded-full">Not Created</span> : <span className="text-green-500 ml-2 bg-green-100 rounded-full">{appointment?.pilot_estimate?.status === "Pending" ? <span className="text-yellow-500 bg-yellow-100 px-2 py-1 rounded-full">Pending</span> : appointment?.pilot_estimate?.status === "Rejected" ? <span className="text-red-500 bg-red-100 px-2 py-1 rounded-full">Rejected</span> : <span className="text-green-500 bg-green-100 px-2 py-1 rounded-full">Approved</span>}</span>   }
                    
                    </p>

                  {/* Bottom Info */}
                  <div className="mt-3 pt-3 border-t border-gray-200 flex justify-between items-center">
                      <div>
                    <div className="text-xs text-gray-500">
                      Booking ID: {appointment.bookingId}
                    </div>
                    
                    </div>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();

                        setWorkOrder(defaultWorkOrder);

                        fetchAppointmentDetails(appointment.id);
                      }}
                      className="text-xs text-customOne hover:text-customOneDark font-medium"
                    >
                      View Details →
                    </button>
                  </div>
                </div>
              ))}
            </div>
        )}
      </div>
    </div>
  );
}

export default AppointmentCard;